import { AttributeFilterItemProps } from "../../../common/interfaces";
import React from "react";
import PlusIcon from "../../../../assets/plus-icn.inline.svg";

import {
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel
} from "react-accessible-accordion";

export const AttributeFilterItem: React.FC<AttributeFilterItemProps> = ({ attributeFilter, children }) => (
  <AccordionItem key={attributeFilter.code} className="attribute-filter-accordion__attribute">
    <AccordionItemHeading>
      <AccordionItemButton className="attribute-filter-accordion__attribute-header">
        <PlusIcon className="attribute-filter-accordion__dropdown-icon" />
        {attributeFilter.label}
      </AccordionItemButton>
    </AccordionItemHeading>
    <AccordionItemPanel className="attribute-filter-accordion__panel">{children}</AccordionItemPanel>
  </AccordionItem>
);
